import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { formatDate } from 'app/helpers/formatDate';
import { formatKennitalaRemoveLine } from 'app/helpers/formatKennitala';
import { formatPhoneNumber } from 'app/helpers/formatPhoneNumber';
import { formatSsn } from 'app/helpers/formatSsn';
import { ValidateKennitalaWithHyphen, ValidatePhoneSpace } from 'app/helpers/validators';
import { ExposedAuthRequestRes } from 'app/interfaces/responses/Exposed/exposedAuthRequestRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { SkjalamidjaService } from 'app/services/api/skjalamidja/skjalamidja.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';

@Component({
    selector: 'app-audkenning-senda-beidni',
    templateUrl: './audkenning-senda-beidni.component.html',
    styleUrls: ['./audkenning-senda-beidni.component.scss'],
})
export class AudkenningSendaBeidniComponent implements OnInit {
    formEnabled = true;
    form: UntypedFormGroup;
    publicAuthRequestUser: ExposedAuthRequestRes;

    @Input() selectedPanelIndex: number = 0;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private alertsService: AlertsService,
        private lsrauthService: LsrauthService,
        private skjalamidja: SkjalamidjaService
    ) {
        this.initForm();
    }

    phoneKeyUp(e) {
        var _phone = this.form.get('phone').value;
        this.form.get('phone').setValue(formatPhoneNumber(_phone));
    }

    socialSecurityNumberKeyUp(e) {
        var _ssn = this.form.get('ssn').value;
        this.form.get('ssn').setValue(formatSsn(_ssn));
    }

    ngOnInit(): void {
        this.skjalamidja.listCategories().subscribe((res) => {});
    }

    initForm() {
        this.publicAuthRequestUser = null;
        this.form = this.formBuilder.group({
            phone: new UntypedFormControl('', [Validators.required]),
            ssn: new UntypedFormControl('', [Validators.required]),
            skilabod: new UntypedFormControl('LSR - Staðfesting á rafrænu auðkenni', [Validators.required]),
            vidbotarupplysingar: new UntypedFormControl(''),
        });
    }

    tabChanged(event: MatTabChangeEvent) {
        if (event.index == 0) {
            this.selectedPanelIndex = 0;
        } else if (event.index == 1) {
            this.selectedPanelIndex = 1;
        }
        localStorage.setItem('selectedPanelIndex', this.selectedPanelIndex.toString());
    }

    determineValidators() {
        this.form.get('ssn').clearValidators();
        this.form.get('phone').clearValidators();
        if (this.selectedPanelIndex == 0) {
            this.form.get('phone').setValidators([Validators.required, ValidatePhoneSpace]);
        } else {
            this.form.get('ssn').setValidators([Validators.required, ValidateKennitalaWithHyphen]);
        }
        this.form.get('phone').updateValueAndValidity();
        this.form.get('ssn').updateValueAndValidity();
    }

    revertAllChanges() {
        if (confirm('Ertu viss um að þú viljir hætta við?')) {
            this.form.markAsPristine();
            this.initForm();
        }
    }

    formatSsn(sn) {
        return formatSsn(sn);
    }

    formatDate(d) {
        return formatDate(d);
    }

    save() {
        this.determineValidators();
        this.publicAuthRequestUser = null;
        if (!this.form.valid) {
            return;
        }

        this.form.disable();
        this.formEnabled = false;

        this.lsrauthService
            .publicAuthRequest({
                authenticationType: this.selectedPanelIndex == 0 ? 'audkenniSim' : 'audkenniApp',
                phonenumber: this.selectedPanelIndex == 0 ? this.form.get('phone').value.replace(/ /g, '') : null,
                socialSecurityNumber: this.selectedPanelIndex == 1 ? formatKennitalaRemoveLine(this.form.get('ssn').value) : null,
                authText: this.form.get('skilabod').value,
                additionalInfo: this.form.get('vidbotarupplysingar').value,
            })
            .subscribe((res) => {
                this.form.enable();
                this.form.markAsPristine();
                this.publicAuthRequestUser = res;
                this.formEnabled = true;
            });
    }
}
